import React, { useState } from 'react'
import '../../styles/videos/InstructionVideos.css'
// import MobileFeed1 from '../../assets/videos/MobileFeed1.png';
// import MobileCreate2 from '../../assets/videos/MobileCreateContent2.png';
// import DesktopFeed3 from '../../assets/videos/DesktopFeed3.png';
// import DesktopCreate4 from '../../assets/videos/DesktopCreateContent4.png';
// import DesktopClassroom5 from '../../assets/videos/DesktopClassroom5.png';
// import DesktopChat6 from '../../assets/videos/DesktopChat6.png';
// import InfoStaff7 from '../../assets/videos/InfoStaff7.png';
// import FullVideo from '../../assets/videos/FullTraining.png';
import VideoModal from '../modals/VideoModal'
import { ReactComponent as VideoIcon } from '../../assets/svg/PlayVideoIcon.svg'
import { useTranslation } from 'react-i18next'
import { usePageTitle } from '../../utils/util'
const FullVideo = 'https://videos.upstrivesystem.com/StaffFullDesktopInstructionVideo.mp4'
const FullMobileVideo = 'https://videos.upstrivesystem.com/40fc08af-9808-47fa-883d-76b60d5ef636.mp4'
const VideoPlaceholder = 'https://files.upstrivesystem.com/public/VideoPlaceholder.png'

function InstructionVideos() {
    usePageTitle('Upstrive Education - Instruction videos')
    const [selectedVideo, setSelectedVideo] = useState({})
    const [selectedIndex, setSelectedIndex] = useState()
    const [videoModalOpen, setVideoModalOpen] = useState(false)
    const { t, locale } = useTranslation()

    const full_videos = [
        { src: FullMobileVideo, title: t('Full Mobile version') },
        { src: FullVideo, title: t('Full Desktop version') },
    ]

    const videos = [
        { src: 'https://videos.upstrivesystem.com/Alerts.m4v', title: 'Alerts' },
        // { src: 'https://videos.upstrivesystem.com/Analytics.m4v', title: 'Analytics' },
        { src: 'https://videos.upstrivesystem.com/Chat.m4v', title: 'Chat' },
        { src: 'https://videos.upstrivesystem.com/Classroom.m4v', title: 'Classroom' },
        { src: 'https://videos.upstrivesystem.com/Content (Create Your Own).m4v', title: 'Content (Create Your Own)' },
        { src: 'https://videos.upstrivesystem.com/Content (Ready To Go).m4v', title: 'Content (Ready To Go)' },
        { src: "https://videos.upstrivesystem.com/Teacher's Dashboard.m4v", title: "Teacher's Dashboard" },
        { src: 'https://videos.upstrivesystem.com/The Wellbeing Tracker.m4v', title: 'The Wellbeing Tracker' },
        { src: 'https://videos.upstrivesystem.com/User Management.m4v', title: 'User Management' },
    ]
    const refreshed_videos = [
        { src: 'https://videos.upstrivesystem.com/Alerts (Refresher).m4v', title: 'Alerts' },
        // { src: 'https://videos.upstrivesystem.com/Analytics.m4v', title: 'Analytics' },
        { src: 'https://videos.upstrivesystem.com/Chat (Refresher).m4v', title: 'Chat' },
        { src: 'https://videos.upstrivesystem.com/Classroom (Refresher).m4v', title: 'Classroom' },
        { src: 'https://videos.upstrivesystem.com/Content (Refresher).m4v', title: 'Content' },
        { src: "https://videos.upstrivesystem.com/Teacher's Dashboard (Refresher).m4v", title: "Teacher's Dashboard" },
        { src: 'https://videos.upstrivesystem.com/The Wellbeing Tracker (Refresher).m4v', title: 'The Wellbeing Tracker' },
        { src: 'https://videos.upstrivesystem.com/User Management (Refresher).m4v', title: 'User Management' },
    ]
    const openVideo = (video, index) => {
        setSelectedVideo(video)
        setSelectedIndex(index)
        setVideoModalOpen(true)
    }
    const closeVideo = () => {
        setVideoModalOpen(false)
    }

    return (
        <div className="page-shell h-full bg-[#ECEBF8] overflow-y-scroll">
            <div className="max-w-[1520px] mx-auto">
                <h1 className="page-title text-left mb-10 text-darkPurple font-bold">{t('instructionVideos')}</h1>
            </div>
            <div className="w-full flex flex-col gap-[50px] max-w-[1520px] mx-auto">
                <div className="bg-white rounded-xl p-10  gap-[50px] ">
                    <div className="flex flex-row items-baseline mb-10 w-full">
                        <h2 className="text-left text-[#5E639B] font-bold text-xl leading-[25px] w-full" style={{ whiteSpace: 'pre-line' }}>
                            {`Full Training Video (30-min)`}
                        </h2>
                    </div>
                    <div className="gap-[45px] grid grid-cols-2 w-full ">
                        <div
                            className="p-8 pointer bg-containerGray rounded-xl flex items-center justify-center flex-col instruction-video-widget"
                            onClick={(e) => {
                                e.preventDefault()
                                openVideo({ src: FullVideo, placeholder: FullVideo, title: 'Full Training' }, 8)
                            }}
                        >
                            <div className="relative mt-2 mb-[20px] w-full">
                                <div className="instruction-image-placeholder absolute flex items-center justify-center rounded-xl w-full h-full t-0 l-0">
                                    <VideoIcon />
                                </div>
                                <img width="400" src={VideoPlaceholder} className="rounded-xl w-full min-h-[230px]" alt="" />
                            </div>
                            <div className="text-left flex flex-col w-full">
                                <p className="font-bold text-darkPurple text-xl">{t('Full Desktop version')} </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex-1 bg-white rounded-xl p-10 flex justify-center flex-col items-center ">
                    <div className="flex flex-row justify-center items-center mb-10 w-full">
                        <h2 className="text-left ml-2 text-deepPurple font-bold text-xl  w-full">{t('individualFeaturesTraining')} </h2>
                    </div>
                    <div className="grid gap-4 w-full individual-video-grid">
                        {videos.map((video, index) => (
                            <div
                                className="instruction-video-widget p-[30px] pointer col-span-1 bg-containerGray rounded-[10px] flex items-center  flex-col"
                                onClick={(e) => {
                                    e.preventDefault()
                                    openVideo(video, index)
                                }}
                                key={index}
                            >
                                <div className="relative mt-2 w-full">
                                    <div className="instruction-image-placeholder absolute flex items-center justify-center rounded-xl w-full h-full t-0 l-0">
                                        <VideoIcon />
                                    </div>
                                    <img width="400" src={VideoPlaceholder} className="rounded-xl w-full min-h-[230px] object-cover" alt="" />
                                </div>
                                <div className="text-left flex flex-col w-full">
                                    <p className="font-bold text-darkPurple text-xl mt-[20px]">{video.title}</p>
                                    {/* <p className="text-left text-[#9392AD] text-sm">
                                        {t('instructionVideosForStaff')} {index + 1}:
                                    </p> */}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="flex-1 bg-white rounded-xl p-10 flex justify-center flex-col items-center ">
                    <div className="flex flex-row justify-center items-center mb-10 w-full">
                        <h2 className="text-left ml-2 text-deepPurple font-bold text-xl  w-full">{t('Refresher Videos')} </h2>
                    </div>
                    <div className="grid gap-4 w-full individual-video-grid">
                        {refreshed_videos.map((video, index) => (
                            <div
                                className="instruction-video-widget p-[30px] pointer col-span-1 bg-containerGray rounded-[10px] flex items-center  flex-col"
                                onClick={(e) => {
                                    e.preventDefault()
                                    openVideo(video, index)
                                }}
                                key={index}
                            >
                                <div className="relative mt-2 w-full">
                                    <div className="instruction-image-placeholder absolute flex items-center justify-center rounded-xl w-full h-full t-0 l-0">
                                        <VideoIcon />
                                    </div>
                                    <img width="400" src={VideoPlaceholder} className="rounded-xl w-full min-h-[230px] object-cover" alt="" />
                                </div>
                                <div className="text-left flex flex-col w-full">
                                    <p className="font-bold text-darkPurple text-xl mt-[20px]">{video.title}</p>
                                    {/* <p className="text-left text-[#9392AD] text-sm">
                                        {t('instructionVideosForStaff')} {index + 1}:
                                    </p> */}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <VideoModal video={selectedVideo} index={selectedIndex} modalIsOpen={videoModalOpen} closeModal={closeVideo} />
        </div>
    )
}

export default InstructionVideos
